export default __webpack_public_path__ + "cdc82cfc979ca3ab1bc79f46c2db206e.png";